<template>
  <div>
    <div v-if="this.loadingScouter || this.loadingReport">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loadingScouter && !this.loadingReport && !this.errormessage">
      <h4>Participants</h4>
      <div class="row">
        <div class="col-md-4">
          <circle-chart-card
            v-if="dashboard.PercentCompleteGoals !== null"
            :percentage="percentGoalsComplete"
            chart-id="goals-complete-chart"
            title="Goal Progress"
            description="Percent Ticket Goals Complete"
            color="#4acccd"
          />
        </div>
        <div class="col-md-4">
          <stats-card
            type="success"
            :title="dashboard.Participants.toString()"
            small-title="Total Participants"
            icon="bi bi-people-fill"
          >
            <div
              class="stats"
              slot="footer"
            >
              <i class="bi bi-people" />
              {{ percentParticipantsPaidInFull }} Participants Paid In Full
            </div>
          </stats-card>
          <stats-card
            type="success"
            :title="dashboard.CompleteGoals.toString()"
            small-title="Goals Complete"
            icon="bi bi-pie-chart-fill"
          >
            <div
              class="stats"
              slot="footer"
            >
              <i class="bi bi-pie chart" />
              {{ dashboard.IncompleteGoals }} Goals Remaining
            </div>
          </stats-card>
        </div>
        <div class="col-md-4">
          <card>
            <slot name="category">
              <h5 class="card-title text-center">
                Participant Reports
              </h5>
            </slot>
            <p-button
              class="mb-3"
              link
              type="info"
              style="width: 100%"
              @click="showPrecourseSignupReport"
            >
              <i class="bi bi-printer mr-2" />Participant Signup Report
            </p-button>
            <p-button
              class="mb-3"
              link
              type="info"
              style="width: 100%"
              @click="showParticipantRoster"
            >
              <i class="bi bi-printer mr-2" />Participant Roster
            </p-button>
            <p-button
              class="mb-3"
              link
              type="info"
              style="width: 100%"
              @click="showApplicationForRecognitionReport"
            >
              <i class="bi bi-printer mr-2" />Application for Training Recognition
            </p-button>
            <p-button
              class="mb-3"
              link
              type="info"
              style="width: 100%"
              @click="showFinalTicketReport"
            >
              <i class="bi bi-printer mr-2" />Final Ticket Report
            </p-button>
          </card>
        </div>
      </div>
      <h4>Staff</h4>
      <div class="row">
        <div class="col-md-4">
          <circle-chart-card
            v-if="dashboard.PercentFirstTimeStaff !== null"
            :percentage="percentFirstTimeStaff"
            chart-id="staff-firsttime-chart"
            title="Staff Makeup"
            description="Percent First Time Staff"
            color="#fcc468"
          />
        </div>
        <div class="col-md-4">
          <stats-card
            type="success"
            v-if="dashboard.TotalWffCollections !== null"
            :title="wffCollections"
            small-title="Friendship Fund"
            icon="bi bi-people-fill"
          >
            <div
              class="stats"
              slot="footer"
            >
              <i class="bi bi-people" />
              {{ wffCollectionsComment }}
            </div>
          </stats-card>
          <stats-card
            type="warning"
            v-if="dashboard.CostToBudget !== null"
            :title="costToBudget"
            small-title="Cost to Budget"
            icon="bi bi-pie-chart-fill"
          >
            <div
              class="stats"
              slot="footer"
            >
              <i class="bi bi-pie chart" />
              {{ costToBudgetPercent }} of budget used
            </div>
          </stats-card>
        </div>
        <div class="col-md-4">
          <card>
            <slot name="category">
              <h5 class="card-title text-center">
                Staff Reports
              </h5>
            </slot>
            <p-button
              class="mb-2"
              link
              type="info"
              style="width: 100%"
              @click="showWorldFriendshipFund"
            >
              <i class="bi bi-printer mr-2" />World Friendship Fund
            </p-button>
            <p-button
              class="mb-2"
              link
              type="info"
              style="width: 100%"
              @click="selectFinanceReportParts"
            >
              <i class="bi bi-printer mr-2" />Financial Summary
            </p-button>
            <p-button
              class="mb-2"
              link
              type="info"
              style="width: 100%"
              @click="showStaffRoster"
            >
              <i class="bi bi-printer mr-2" />Staff Roster
            </p-button>
            <p-button
              class="mb-2"
              link
              type="info"
              style="width: 100%"
              :disabled="!isCourseDirector"
              @click="showCourseDirectorCloseout"
            >
              <i class="bi bi-printer mr-2" />Course Director Closeout
            </p-button>
          </card>
        </div>
      </div>
      <modal
        :show.sync="showSelectParticipant"
        class="modal-primary"
        :show-close="false"
        header-classes="justify-content-center"
        type="mini"
      >
        <div
          slot="header"
          class="ml-4"
        >
          <h6>
            <i class="ti ti-receipt mr-2" />
            <span class="text-danger">Application for Training Recognition</span>
          </h6>
        </div>
        <ValidationObserver ref="form">
          <form @submit.prevent="validate">
            <div class="row">
              <div class="col-12">
                <ValidationProvider
                  name="participant"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <fg-input>
                    <label>Please select a Participant</label>
                    <el-select
                      class="select-default2"
                      size="large"
                      :error="failed ? 'Please select a Participant' : null"
                      :has-success="passed"
                      name="participant"
                      placeholder=""
                      v-model="participantScouterKey"
                    >
                      <el-option
                        v-for="(data, index) in scouters"
                        class="select-default2"
                        :value="index"
                        :label="data"
                        :key="data"
                      />
                    </el-select>
                  </fg-input>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
        <template slot="footer">
          <p-button
            type="danger"
            class="mr-2"
            @click="showSelectParticipant = false"
          >
            Cancel
          </p-button>
          <p-button
            type="success"
            class="mr-2"
            @click="selectParticipant"
          >
            Select
          </p-button>
        </template>
      </modal>
      <modal
        :show.sync="showSelectFinanceReportParts"
        class="modal-primary"
        :show-close="false"
        header-classes="justify-content-center"
        type="mini"
      >
        <div
          slot="header"
          class="ml-4"
        >
          <h6>
            <i class="ti ti-receipt mr-2" />
            <span class="text-danger">Application for Training Recognition</span>
          </h6>
        </div>
        <div class="row">
          <div class="col-12">
            <p-checkbox v-model="showBudgetSummary">
              Budget Summary
            </p-checkbox>
            <p-checkbox v-model="showBudgetDetails">
              Budget Details
            </p-checkbox>
            <p-checkbox v-model="showReimbursementSummary">
              Reimbursement Summary
            </p-checkbox>
            <p-checkbox v-model="showReimbursementDetails">
              Reimbursement Details
            </p-checkbox>
            <p-checkbox v-model="showReceipts">
              Receipt Images
            </p-checkbox>
          </div>
        </div>
        <template slot="footer">
          <p-button
            type="danger"
            class="mr-2"
            @click="showSelectFinanceReportParts = false"
          >
            Cancel
          </p-button>
          <p-button
            type="success"
            class="mr-2"
            @click="showFinanceReport"
          >
            Select
          </p-button>
        </template>
      </modal>
      <report-world-friendship-fund
        v-show="showPrint"
      />
      <report-staff-roster v-show="showPrint" />
      <report-application-for-recognition
        v-if="participantScouterKey"
        :key="participantScouterKey"
        v-show="showPrint"
        :scouter-key="participantScouterKey"
      />
      <report-final-ticket v-show="showPrint" />
      <report-participant-roster v-show="showPrint" />
      <report-precourse-signup v-show="showPrint" />
      <report-budget
        v-show="showPrint"
        :show-budget-summary="showBudgetSummary"
        :show-budget-details="showBudgetDetails"
        :show-reimbursement-summary="showReimbursementSummary"
        :show-reimbursement-details="showReimbursementDetails"
        :show-receipts="showReceipts"
      />
    </div>
  </div>
</template>

<script>
import StatsCard from '@/plugins/paper-components/cards/stats-card.vue'
import CircleChartCard from '@/plugins/paper-components/cards/circle-chart-card.vue'
import ReportWorldFriendshipFund from '@/components/reports/report-world-friendship-fund.vue'
import ReportStaffRoster from '@/components/reports/report-staff-roster.vue'
import ReportApplicationForRecognition from '@/components/reports/report-application-for-recognition.vue'
import ReportFinalTicket from '@/components/reports/report-final-ticket.vue'
import ReportParticipantRoster from '@/components/reports/report-participant-roster.vue'
import ReportPrecourseSignup from '@/components/reports/report-precourse-signup.vue'
import ReportBudget from '@/components/reports/budget/report-budget.vue'
import scouterApi from '@/services/api/scouter'
import reportApi from '@/services/api/reports.js'
import formatter from '@/services/formatter.js'
import Modal from '@/plugins/paper-components/modal.vue'
import PCheckbox from '@/plugins/paper-components/inputs/p-checkbox.vue'

// For testing
// import HtmlToPaperTest from '@/plugins/vue-html-to-paper-test.js'

export default {
  name: 'Reports',
  components: {
    StatsCard,
    CircleChartCard,
    ReportWorldFriendshipFund,
    ReportStaffRoster,
    ReportApplicationForRecognition,
    ReportFinalTicket,
    ReportParticipantRoster,
    ReportPrecourseSignup,
    ReportBudget,
    Modal,
    PCheckbox
  },
  data: function () {
    return {
      dashboard: {
        Participants: '',
        CompleteGoals: '',
        IncompleteGoals: '',
        PercentCompleteGoals: null,
        PercentFirstTimeStaff: null,
        TotalWffCollections: null,
        CostToBudget: null,
        PercentToBudget: null
      },
      fakeData: [60, 10, 40],
      fakeLabels: [1, 2],
      showPrint: false,
      printItem: '',
      printOptions: null,
      scouters: [],
      showSelectFinanceReportParts: false,
      buildFinanceReport: false,
      showSelectParticipant: false,
      participantScouterKey: null,
      showBudgetSummary: false,
      showBudgetDetails: false,
      showReimbursementSummary: false,
      showReimbursementDetails: false,
      showReceipts: false,
      loadingScouter: true,
      loadingReport: true,
      errormessage: ''
    }
  },
  watch: {
    printItem: function (oldValue, newValue) {
      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper(this.printItem, this.printOptions)
        }
        this.printItem = ''
      })
    }
  },
  computed: {
    isCourseDirector: function () {
      return this.$root.isCourseDirector
    },
    percentParticipantsPaidInFull: function () {
      return formatter.formatAsPercent(
        this.dashboard.PercentParticipantsPaidInFull
      )
    },
    percentGoalsComplete: function () {
      return Math.round(this.dashboard.PercentCompleteGoals * 100)
    },
    percentFirstTimeStaff: function () {
      return Math.round(this.dashboard.PercentFirstTimeStaff * 100)
    },
    wffCollections: function () {
      return formatter.formatAsCurrency(this.dashboard.TotalWffCollections, 2)
    },
    wffCollectionsComment: function () {
      if (this.dashboard.TotalWffCollections === 0) {
        return 'nothing collected yet'
      } else {
        return 'tidy little sum'
      }
    },
    costToBudget: function () {
      return formatter.formatAsCurrency(this.dashboard.CostToBudget, 2)
    },
    costToBudgetPercent: function () {
      return formatter.formatAsPercent(this.dashboard.PercentToBudget)
    }
  },
  mounted: function () {
    scouterApi
      .getParticipantLookups(this.$root.courseKey)
      .then(x => {
        this.scouters = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loadingScouter = false
      })
    reportApi
      .getReportDashboard(this.$root.courseKey)
      .then(x => {
        this.dashboard = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loadingReport = false
      })
  },
  methods: {
    showReport: function (elementName, isLandscape) {
      switch (elementName) {
        case 'wffReport':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/world-friendship-fund.css'
            ]
          }
          break
        case 'precoursesignup':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/two-beads-print-landscape.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/precourse-signup.css'
            ]
          }
          break
        case 'participantroster':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/two-beads-print-landscape.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/participant-roster.css'
            ]
          }
          break
        case 'app4recognition':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/recognition.css'
            ]
          }
          break
        case 'finalticket':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/two-beads-print-landscape.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/final-ticket.css'
            ]
          }
          break
        case 'staffroster':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/two-beads-print-landscape.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/staff-roster.css'
            ]
          }
          break
        case 'budgetreport':
          this.printOptions = {
            styles: [
              '/kidlat.css',
              '/bootstrap.min.css',
              '/chalk-theme.css',
              '/printer-styles/two-beads-print.css',
              '/printer-styles/header-footer.css',
              '/printer-styles/budget.css'
            ]
          }
          break
      }
      this.printItem = elementName
    },
    showWorldFriendshipFund: function () {
      this.showReport('wffReport', false)
    },
    showStaffRoster: function () {
      this.showReport('staffroster', true)
    },
    showFinalTicketReport: function () {
      this.showReport('finalticket', true)
    },
    showParticipantRoster: function () {
      this.showReport('participantroster', true)
    },
    showPrecourseSignupReport: function () {
      this.showReport('precoursesignup', true)
    },
    showApplicationForRecognitionReport: function () {
      this.participantScouterKey = null
      this.showSelectParticipant = true
    },
    selectParticipant: function () {
      this.showSelectParticipant = false
      this.showReport('app4recognition', false)
    },
    selectFinanceReportParts: function () {
      this.showBudgetSummary = false
      this.showBudgetDetails = false
      this.showReimbursementSummary = false
      this.showReimbursementDetails = false
      this.showReceipts = false
      this.showSelectFinanceReportParts = true
    },
    showFinanceReport: function () {
      this.showSelectFinanceReportParts = false
      this.buildFinanceReport = true
      this.showReport('budgetreport', false)
    },
    showCourseDirectorCloseout: function () {
      if (this.$route.path !== '/staff/reports/closeout') {
        this.$router.push('/staff/reports/closeout')
      }
    }
  }
}
</script>
